module.exports = __webpack_public_path__ + "static/media/Rectangle 94.ff29bdee.png";